"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUseGlobalState = exports.injectGlobalStatesInSearchParams = exports.globalStates = void 0;
var react_1 = require("react");
var evt_1 = require("evt");
var hooks_1 = require("evt/hooks");
var useConstCallback_1 = require("./useConstCallback");
var overwriteReadonlyProp_1 = require("tsafe/lab/overwriteReadonlyProp");
var typeGuard_1 = require("tsafe/typeGuard");
var capitalize_1 = require("./tools/capitalize");
var memoizee_1 = __importDefault(require("memoizee"));
var urlSearchParams_1 = require("./tools/urlSearchParams");
var _a = (function () {
    var propertyKey = "__powerhooks_useGlobalState_context";
    var peerDepObj = react_1.createContext;
    var sharedContext = peerDepObj.__powerhooks_useGlobalState_context;
    if (sharedContext === undefined) {
        sharedContext = {
            "globalStates": {},
            "persistedGlobalStateNames": new Set()
        };
        Object.defineProperty(peerDepObj, propertyKey, {
            "configurable": false,
            "enumerable": false,
            "writable": false,
            "value": sharedContext
        });
    }
    return sharedContext;
})(), globalStates = _a.globalStates, persistedGlobalStateNames = _a.persistedGlobalStateNames;
exports.globalStates = globalStates;
function stringify(obj) {
    return JSON.stringify([obj]);
}
function parse(str) {
    return JSON.parse(str)[0];
}
var prefix = "powerhooks_useGlobalState_";
var _b = (function () {
    /** Returns the modified url */
    function injectGlobalStatesInSearchParams(url) {
        var newUrl = url;
        Object.keys(globalStates)
            .filter(function (name) { return persistedGlobalStateNames.has(name); })
            .forEach(function (name) {
            return newUrl =
                (0, urlSearchParams_1.addParamToUrl)({
                    "url": newUrl,
                    "name": "".concat(prefix).concat(name),
                    "value": stringify(globalStates[name])
                })
                    .newUrl;
        });
        return newUrl;
    }
    var getUnparsedStatesFromUrlSearchParams = (0, memoizee_1.default)(function () {
        var _a = (0, urlSearchParams_1.retrieveAllParamStartingWithPrefixFromUrl)({
            "url": window.location.href,
            prefix: prefix,
            "doLeavePrefixInResults": false
        }), newUrl = _a.newUrl, unparsedStates = _a.values;
        (0, urlSearchParams_1.updateSearchBarUrl)(newUrl);
        return { unparsedStates: unparsedStates };
    });
    function getStatesFromUrlSearchParams(params) {
        var name = params.name;
        var unparsedStates = getUnparsedStatesFromUrlSearchParams().unparsedStates;
        if (!(name in unparsedStates)) {
            return { "wasPresent": false };
        }
        return {
            "wasPresent": true,
            "state": parse(unparsedStates[name])
        };
    }
    return {
        injectGlobalStatesInSearchParams: injectGlobalStatesInSearchParams,
        getStatesFromUrlSearchParams: getStatesFromUrlSearchParams
    };
})(), injectGlobalStatesInSearchParams = _b.injectGlobalStatesInSearchParams, getStatesFromUrlSearchParams = _b.getStatesFromUrlSearchParams;
exports.injectGlobalStatesInSearchParams = injectGlobalStatesInSearchParams;
/**
 *
 * Assert: If localStorageKey is not disabled, T must be
 * serializable with JSON.stringify.
 *
 * const { useFoo } = createUseGlobalState2({
 *     "getDefaultState": ()=> 33,
 *     "name": "foo"
 * });
 *
 * const { foo, setFoo  } = useFoo();
 *
 * By default persistance is enabled using localStorage.
 *
 */
function createUseGlobalState(name, 
/** If function called only if not in local storage */
initialState, params) {
    var _a;
    var _b = (params !== null && params !== void 0 ? params : {}).persistance, persistance = _b === void 0 ? "localStorage" : _b;
    var persistentStorage = persistance === false ?
        undefined :
        (function () {
            var result = getPersistentStorage({
                "mechanism": persistance,
                "key": (function () {
                    if (Object.keys(globalStates).includes(name)) {
                        console.warn("".concat(name, " already in use"));
                    }
                    return "".concat(prefix).concat(name);
                })()
            });
            if (!result.isSupported) {
                console.warn([
                    "powerhooks warning, persistance mechanism ".concat(persistance),
                    "is not supported by the current runtime, state of ".concat(name),
                    "will not be saved"
                ].join(" "));
                return undefined;
            }
            return result.persistanceStorage;
        })();
    if (persistentStorage !== undefined) {
        persistedGlobalStateNames.add(name);
    }
    //NOTE: We want to clean the url asap so we don't put it in the 
    // evt getter... but we don't clean it up because powerhooks version clash...TODO
    var urlSearchParam = typeof location === "undefined" ?
        { "wasPresent": false } :
        getStatesFromUrlSearchParams({ name: name });
    var getEvtXyz = (0, memoizee_1.default)(function () {
        var storeStateInPersistentStorage = persistentStorage == undefined ?
            undefined :
            function (state) { return persistentStorage.setItem(stringify(state)); };
        var evtXyz = evt_1.Evt.create((function () {
            if (urlSearchParam.wasPresent) {
                var state = urlSearchParam.state;
                storeStateInPersistentStorage === null || storeStateInPersistentStorage === void 0 ? void 0 : storeStateInPersistentStorage(state);
                return state;
            }
            if (persistentStorage !== undefined) {
                var serializedState = persistentStorage.getItem();
                if (serializedState !== null) {
                    return parse(serializedState);
                }
            }
            return (0, typeGuard_1.typeGuard)(initialState, typeof initialState === "function") ?
                initialState() :
                initialState;
        })());
        //Susceptible to have one handler attached for every component.
        evtXyz.setMaxHandlers(Infinity);
        if (storeStateInPersistentStorage !== undefined) {
            evtXyz.attach(storeStateInPersistentStorage);
        }
        return evtXyz;
    });
    Object.defineProperty(globalStates, name, {
        "enumerable": true,
        "get": function () { return getEvtXyz().state; }
    });
    function useXyz() {
        var _a;
        var evtXyz = getEvtXyz();
        var _b = __read((0, react_1.useState)(evtXyz.state), 2), xyz = _b[0], setXyz = _b[1];
        (0, hooks_1.useEvt)(function (ctx) { return evtXyz
            .toStateless(ctx)
            .attach(setXyz); }, []);
        return _a = {},
            _a[name] = xyz,
            _a["set".concat((0, capitalize_1.capitalize)(name))] = (0, useConstCallback_1.useConstCallback)(function (setStateAction) {
                return evtXyz.state =
                    (0, typeGuard_1.typeGuard)(setStateAction, typeof setStateAction === "function") ?
                        setStateAction(xyz) :
                        setStateAction;
            }),
            _a;
    }
    (0, overwriteReadonlyProp_1.overwriteReadonlyProp)(useXyz, "name", "use".concat((0, capitalize_1.capitalize)(name)));
    return Object.defineProperty((_a = {}, _a[useXyz.name] = useXyz, _a), "evt".concat((0, capitalize_1.capitalize)(name)), {
        "enumerable": true,
        "get": function () { return getEvtXyz(); }
    });
}
exports.createUseGlobalState = createUseGlobalState;
var getPersistentStorage = (function () {
    function getLocalStorageImplementationOfPersistantStorage(params) {
        var key = params.key;
        return {
            "getItem": function () { return localStorage.getItem(key); },
            "setItem": function (value) { return localStorage.setItem(key, value); }
        };
    }
    function getCookieImplementationOfPersistantStorage(params) {
        var key = params.key;
        return {
            "getItem": function () {
                var _a, _b, _c;
                return (_c = (_b = (_a = document.cookie
                    .split("; ")
                    .find(function (row) { return row.startsWith("".concat(key, "=")); })) === null || _a === void 0 ? void 0 : _a.split("=")) === null || _b === void 0 ? void 0 : _b[1]) !== null && _c !== void 0 ? _c : null;
            },
            "setItem": function (value) {
                var newCookie = "".concat(key, "=").concat(value, ";path=/;max-age=31536000");
                //TODO: Use https://dev.to/debosthefirst/how-to-use-cookies-for-persisting-users-in-nextjs-4617?signin=true
                //to make it work with nextJs.
                //We do not set the domain if we are on localhost or an ip
                if (window.location.hostname.match(/\.[a-zA-Z]{2,}$/)) {
                    newCookie += ";domain=".concat(window.location.hostname.split(".").length >= 3 ?
                        window.location.hostname.replace(/^[^.]+\./, "") :
                        window.location.hostname);
                }
                document.cookie = newCookie;
            }
        };
    }
    function getPersistentStorage(params) {
        var key = params.key, mechanism = params.mechanism;
        switch (mechanism) {
            case "localStorage":
                return typeof localStorage === "undefined" ?
                    { "isSupported": false } :
                    {
                        "isSupported": true,
                        "persistanceStorage": getLocalStorageImplementationOfPersistantStorage({ key: key })
                    };
            case "cookie":
                return (typeof document === "undefined" ||
                    !(document instanceof Object &&
                        "cookie" in document)) ?
                    { "isSupported": false } :
                    {
                        "isSupported": true,
                        "persistanceStorage": getCookieImplementationOfPersistantStorage({ key: key })
                    };
        }
    }
    return { getPersistentStorage: getPersistentStorage };
})().getPersistentStorage;
//# sourceMappingURL=useGlobalState.js.map